import { getTermValue } from './helpers';
import { EFacilityType, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

export function getAllFacilities(jsonQuery: TJsonQuery): NonEmptyArray<EFacilityType> | null {
  const hasBath = getTermValue('bath')(jsonQuery);
  const hasShower = getTermValue('shower')(jsonQuery);
  const hasConditioner = getTermValue('conditioner')(jsonQuery);
  const hasFurniture = getTermValue('has_furniture')(jsonQuery);
  const hasInternet = getTermValue('internet')(jsonQuery);
  const hasFridge = getTermValue('has_fridge')(jsonQuery);
  const hasPhone = getTermValue('phone')(jsonQuery);
  const hasDishwasher = getTermValue('dish_washer')(jsonQuery);
  const hasKitchenFurniture = getTermValue('has_kitchen_furniture')(jsonQuery);
  const hasTV = getTermValue('tv')(jsonQuery);
  const hasWasher = getTermValue('has_washer')(jsonQuery);
  const kidsAllowed = getTermValue('kids')(jsonQuery);
  const petsAllowed = getTermValue('pets')(jsonQuery);
  const hasSauna = getTermValue('bathhouse')(jsonQuery);
  const hasGarage = getTermValue('garage')(jsonQuery);
  const hasSecurity = getTermValue('security')(jsonQuery);
  const hasPool = getTermValue('pool')(jsonQuery);

  const facilities: EFacilityType[] = [];

  if (hasBath) {
    facilities.push(EFacilityType.Bath);
  }

  if (hasShower) {
    facilities.push(EFacilityType.Shower);
  }

  if (hasConditioner) {
    facilities.push(EFacilityType.Conditioner);
  }

  if (hasFurniture) {
    facilities.push(EFacilityType.RoomFurniture);
  }

  if (hasKitchenFurniture && hasFurniture !== false) {
    facilities.push(EFacilityType.KitchenFurniture);
  }

  if (hasFurniture === false) {
    facilities.push(EFacilityType.WithoutFurniture);
  }

  if (hasInternet) {
    facilities.push(EFacilityType.Internet);
  }

  if (hasFridge) {
    facilities.push(EFacilityType.Fridge);
  }

  if (hasPhone) {
    facilities.push(EFacilityType.Phone);
  }

  if (hasDishwasher) {
    facilities.push(EFacilityType.Dishwasher);
  }

  if (hasTV) {
    facilities.push(EFacilityType.TV);
  }

  if (hasWasher) {
    facilities.push(EFacilityType.Washer);
  }

  if (kidsAllowed) {
    facilities.push(EFacilityType.KidsAllowed);
  }

  if (petsAllowed) {
    facilities.push(EFacilityType.PetsAllowed);
  }

  if (hasSauna) {
    facilities.push(EFacilityType.Sauna);
  }

  if (hasGarage) {
    facilities.push(EFacilityType.Garage);
  }

  if (hasSecurity) {
    facilities.push(EFacilityType.Security);
  }

  if (hasPool) {
    facilities.push(EFacilityType.Pool);
  }

  return nonEmptyArrayOr(facilities);
}
